import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=12d5d2c0&"
import script from "./Privacy.vue?vue&type=script&lang=ts&"
export * from "./Privacy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports